import { HttpModel } from './httpModel.class'

export class HttpDirectBillingFallback extends HttpModel {
  constructor() {
    super()
    const error = () => {
      throw new Error('Direct billing API is not available.')
    }
    this.base = {
      get: error,
      post: error,
      put: error,
      patch: error,
      delete: error
    }
  }

  public setBillingJwt(_token: string) {
    // no-op
  }
}
